<template>
  <div>
    <popover-right v-model="isShowOperate" width="800px" :closed="cancel" :completeClose="cancel">
      <h1 class="popover-right-title approve-dialog">审批人设置</h1>
      <el-tabs type="border-card" class="system-tab-card" v-model="operateType">
        <el-tab-pane label="审批人设置" name="user">
          <div class="a-member-list">
            <p class="result">说明：</p>
            <p class="result">1、当每个配置有多个人时，其中任意一人审批后立即生效</p>
            <p class="result">2、所属部门即上级部门负责人，指需要提交人所属部门和上级部门的负责人依次审批，直到所属部门往上追溯 3 个部门负责人审批完成。</p>
            <p class="result">3、部门负责人，指提交人所属部门负责人审批</p>
            <div class="radio-con">
              <el-radio-group v-model="originType">
                <el-radio label="department">
                  <span class="checkbox-label">部门负责人</span>
                </el-radio>
                <el-radio label="appoint">
                  <span class="checkbox-label">指定人员（任意一人）</span>
                </el-radio>
                <el-radio label="topDepartment">
                  <span class="checkbox-label">所属部门及上级部门负责人（最多三级）</span>
                </el-radio>
              </el-radio-group>
            </div>
            <template v-if="originType === 'appoint'">
              <div class="list-per" v-if="!isShow">
                <div class="flex-all">
                  <template v-if="appointList.length > 0">
                    <span class="person" v-for="(person, index) in appointList" :key="person.id">
                      {{person.name || '--'}}
                      <i class="iconfont iconguanbi" @click="remove(index)"></i>
                    </span>
                  </template>
                  <p class="user-list-none" v-else>请选择审批人</p>
                </div>
                <i class="iconfont add-btn-a icon-add3" @click="checkUser"></i>
              </div>
              <div class="list-per list-per-show-only" v-else>
                <div class="flex-all">
                  <template v-if="appointList.length > 0">
                    <span class="person" v-for="(person) in appointList" :key="person.id">
                      {{person.name || '--'}}
                    </span>
                  </template>
                  <p class="none-people" v-else>暂无相关审批人</p>
                </div>
              </div>
            </template>
            <template v-if="originType === 'department'">
              <el-cascader
                class="operate-member"
                v-model="depart"
                :key="isResouceShow"
                :options="departmentList"
                :props="options"
                placeholder="请选择部门"
                :show-all-levels="false"
                clearable
              >
              </el-cascader>
            </template>
          </div>
          <div class="custom-btn btn-setting-ope">
            <el-button type="primary" @click="confirm" v-if="!isShow">保存</el-button>
            <el-button type="info" @click="isShowOperate = false">取消</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="表单操作权限" name="permission" v-if="voucher_type >= 9 && voucher_type <= 12">
          <div class="a-member-list">
            <div class="radio-con">
              <el-radio-group v-model="formType">
                <span>表单字段：</span>
                <el-radio :label="1">
                  <span class="checkbox-label">可编辑</span>
                </el-radio>
                <el-radio :label="0">
                  <span class="checkbox-label">只读</span>
                </el-radio>
              </el-radio-group>
            </div>
            <div class="summary-a">
              订单金额，佣金
            </div>
          </div>
          <div class="custom-btn btn-setting-ope">
            <el-button type="primary" @click="confirmPermission" v-if="!isShow">保存</el-button>
            <el-button type="info" @click="isShowOperate = false">取消</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </popover-right>
    <select-company-member ref="systemSelectMember" :user_permission="3" v-if="isShowOperate" @confirm="confirmCheck" />
  </div>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import selectCompanyMember from './../../components/selectCompanyMember';
import {getCompanyAllChild} from '@/api/firm';
export default {
  name: 'SystemOperateMember',
  components: {
    PopoverRight,
    selectCompanyMember
  },
  data () {
    return {
      operateType: 'user',
      isShowOperate: false,
      formType: 0,
      originType: 'department',
      appointList: [],
      departmentList: [],
      depart: [0],
      isResouceShow: 0,
      options: {
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'id', 
        label: 'name'
      },
      voucher_type: '',
      isShow: false
    }
  },
  mounted () {
    this.initCurrentDepart();
    const {type, isShow} = this.$route.query;
    this.voucher_type = Number(type);
    this.isShow = isShow === 'isShow';
  },
  methods: {
    open (data, index) {
      this.isShowOperate = true;
      if(data.setting_type > 0){
        this.originType = data.setting_type === 1 ? 'department' : (data.setting_type === 2 ? 'appoint' : 'topDepartment') ;
      }else{
        this.originType = 'department'
      }
      if (data.setting_type === 1) {
        const n = Number(data.approval_admin_list);
        this.depart = n === 0 ? [n] : n;
      } else if (data.setting_type === 2) {
        let names = (data.approval_admin_type_name || '').split(',');
        let ids = (data.approval_admin_list ? `${data.approval_admin_list}` : '').split(',');
        this.appointList = names.map((v, i) => {
          return {
            name: v,
            id: Number(ids[i])
          }
        }) || [];
      }
      this.formType = data.edit_setting;
      this.index = index;
    },
    cancel () {
      this.isShowOperate = false;
      this.depart = [0];
      this.appointList = [];
      this.formType = 0;
      this.operateType= 'user';
    },
    remove (index) {
      this.appointList.splice(index, 1);
    },
    checkUser () {
      const {type} = this.$route.query;
      this.$refs.systemSelectMember && this.$refs.systemSelectMember.open(this.appointList, 1, {voucher_type: type});
    },
    async initCurrentDepart () {
      try {
        const res = await getCompanyAllChild();
        const data = [{id: 0, name: '申请人所在部门'}];
        this.departmentList = [...data, ...(res || [])];
      } catch (error) {
        this.$message.error(error.msg || '获取当前用户权限的下级部门列表出现错误');
      }
    },
    confirm () {
      // 请设置审批人
      let value = '';
      let name = '';
      if (this.originType === 'department') {
        if (this.depart.length <= 0) {
          this.$message.error('请选择审批人');
          return null;
        }
        name = $('.operate-member input').val();
        value = this.depart[this.depart.length - 1];
      } else if (this.originType === 'appoint') {
        if (this.appointList.length <= 0) {
          this.$message.error('请选择审批人');
          return null;
        }
        name = this.appointList.map(v => v.name).join(',');
        value = this.appointList.map(v => v.id).join(',');
      }
      else if (this.originType === 'topDepartment') {
        name = '所属部门及上级部门负责人';
      }
      if(this.originType === 'topDepartment'){
        this.$emit('callback', {
          approval_admin_type_name: name,
          setting_type: this.originType === 'department' ?  1 : (this.originType === 'appoint' ? 2 : 3 )
        }, this.index);
      }else{
        this.$emit('callback', {
          approval_admin_list: value,
          approval_admin_type_name: name,
          setting_type: this.originType === 'department' ?  1 : (this.originType === 'appoint' ? 2 : 3 )
        }, this.index);
      }
     
      this.cancel();
    },
    confirmCheck (list) {
      this.appointList = list;
    },
    confirmPermission () {
      this.$emit('permissionBack', this.formType, this.index);
      this.cancel();
    }
  }
}
</script>
<style lang="less">
.operate-member{
  width: 100%;
  margin-top: 27px;
}
.none-people{
  font-size: 13px;
  color: #666;
  padding-bottom: 15px;
  padding-top: 5px;
}
</style>